export default function MessengerSvg() {
  return (
    <svg
      fill='none'
      height='24'
      viewBox='0 0 24 24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_341_487)'>
        <path
          d='M12 0C5.241 0 0 4.953 0 11.64C0 15.138 1.434 18.162 3.768 20.25C3.963 20.424 4.083 20.67 4.089 20.934L4.155 23.07C4.15981 23.2272 4.20314 23.3807 4.2812 23.5172C4.35926 23.6537 4.46965 23.769 4.60267 23.8528C4.73569 23.9366 4.88726 23.9865 5.04408 23.9981C5.20089 24.0096 5.35814 23.9825 5.502 23.919L7.884 22.869C8.085 22.779 8.313 22.764 8.526 22.821C9.621 23.121 10.785 23.283 12 23.283C18.759 23.283 24 18.33 24 11.643C24 4.956 18.759 0 12 0Z'
          fill='url(#paint0_radial_341_487)'
        />
        <path
          d='M4.79401 15.0451L8.31901 9.45309C8.45162 9.24256 8.62643 9.0618 8.83242 8.92223C9.0384 8.78267 9.27109 8.68732 9.51578 8.64222C9.76047 8.59711 10.0119 8.60323 10.2541 8.66018C10.4963 8.71713 10.7241 8.82368 10.923 8.97309L13.728 11.0761C13.8532 11.1698 14.0056 11.2203 14.162 11.2197C14.3184 11.2192 14.4704 11.1677 14.595 11.0731L18.381 8.19909C18.885 7.81509 19.545 8.42109 19.209 8.95809L15.681 14.5471C15.5484 14.7576 15.3736 14.9384 15.1676 15.078C14.9616 15.2175 14.7289 15.3129 14.4842 15.358C14.2395 15.4031 13.9882 15.397 13.746 15.34C13.5037 15.2831 13.276 15.1765 13.077 15.0271L10.272 12.9241C10.1468 12.8303 9.99444 12.7799 9.83801 12.7805C9.68158 12.781 9.52958 12.8325 9.40501 12.9271L5.61901 15.8011C5.11501 16.1851 4.45501 15.5821 4.79401 15.0451Z'
          fill='white'
        />
      </g>
      <defs>
        <radialGradient
          cx='0'
          cy='0'
          gradientTransform='translate(4.02 24) scale(26.4 26.4)'
          gradientUnits='userSpaceOnUse'
          id='paint0_radial_341_487'
          r='1'
        >
          <stop stopColor='#0099FF' />
          <stop offset='0.6' stopColor='#A033FF' />
          <stop offset='0.9' stopColor='#FF5280' />
          <stop offset='1' stopColor='#FF7061' />
        </radialGradient>
        <clipPath id='clip0_341_487'>
          <rect fill='white' height='24' width='24' />
        </clipPath>
      </defs>
    </svg>
  )
}
